export default "/assets/images/wall-of-love-hero-loop.mp4?5e21da1dc5fd22fbe9ab7c13b5c0c5ac";